import { RouteConfig } from 'vue-router';
import Layout from '@/layout/index.vue'

const dashboardRoutes: RouteConfig = {
  path: '/dashboard',
  component: Layout,
  meta: {
    title: 'dashboard',
    icon: 'dashboard',
    redirect: '/dashboard/dashboard',
  },
  children: [
    {
      path: 'dashboard',
      component: () => import('@/views/dashboard/dashboard.vue'),
      meta: {
        noCache: true,
        title: 'dashboard',
        icon: 'dashboard',
        activeMenu: '/dashboard/dashboard'
      }
    }
  ]
}

export default dashboardRoutes